module.exports = __webpack_public_path__ + "img/24-3D2.95c4480.png";